import React from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import CallToActionBanner from "../components/CallToActionBanner";
import { categories, heroImages, HIDDEN_CATEGORIES } from "../mock";
import { ArrowRight } from "lucide-react";
import SEO from "../components/SEO";

export default function Categories() {
  const visible = categories.filter((c) => !HIDDEN_CATEGORIES.includes(c.slug));
  return (
    <>
      <SEO
        title="Commodity Categories — Industrial Raw Materials"
        description="Browse Ruken Alazdehar's core commodity categories: Cement Raw Materials (Clinker, Limestone, Gypsum, Slag, Fly Ash, Construction Aggregates), Coal and Petroleum Products."
        path="/product-categories"
      />
      <PageHero
        title="Our Commodity Categories"
        subtitle="We provide a wide range of high-quality industrial raw materials, finished products and related items. Our products meet the highest industry standards and cater to various markets globally."
        breadcrumbs={[{ label: "Commodities" }]}
        bgImage={heroImages.main}
      />
      <section className="section-padding">
        <div className="max-w-7xl mx-auto px-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {visible.map((c) => (
            <Link key={c.slug} to={`/products/${c.slug}`} className="group bg-white rounded-xl border border-border overflow-hidden card-hover fade-in">
              <div className="relative aspect-[4/3] overflow-hidden">
                <img src={c.image} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute top-4 left-4 px-3 py-1 rounded-full text-white text-[11px] font-semibold uppercase tracking-wider" style={{ background: "var(--brand-700)" }}>
                  Category {c.code}
                </div>
              </div>
              <div className="p-6">
                <h3 className="font-display text-lg font-bold text-brand" style={{ color: "var(--brand-700)" }}>{c.title}</h3>
                <p className="mt-2 text-sm text-muted-foreground line-clamp-2">{c.short}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-accent group-hover:gap-3 transition-all" style={{ color: "var(--brand-500)" }}>
                  Explore <ArrowRight size={14} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>
      <CallToActionBanner />
    </>
  );
}
